import React from 'react';

import { Container, ContainerItem } from './StyledComponents';

import LabOrderPartnerComms from "./LabOrderPartnerComms";
import LabRequestPayoutConfirmation from "./LabRequestPayoutConfirmation";

import LabOrderActivities from './LabOrderActivities';
import PolicyDetails from "../policy-details/PolicyDetails";


export default class LabOrderTableSubComponent extends React.Component {
    render() {
        const { orderInfo } = this.props;
        return (
            <Container>
                <ContainerItem style={{ flex: 2 }}>
                    <LabRequestPayoutConfirmation orderId={orderInfo.orderId} partnerId={orderInfo.partnerId}/>
                    <br />
                    <LabOrderPartnerComms orderId={orderInfo.orderId} />
                </ContainerItem>
                <ContainerItem style={{ flex: 6 }}>
                    <PolicyDetails userId={orderInfo.userId} />
                </ContainerItem>
                <ContainerItem style={{ flex: 6 }}>
                    <LabOrderActivities orderId={orderInfo.orderId} />
                </ContainerItem>
            </Container>
        );
    }
}
